// @flow
import TeamPlayer from 'components/team/TeamPlayer';
import { connect } from 'react-redux';

import type { DispatchType, StateType } from 'types/Actions';
import type { StateProps, DispatchProps } from 'components/team/TeamPlayer';
import { fetchPageList } from 'actions/pageActions';
import { fetchJoueur, resetJoueur } from 'actions/joueurActions';
import { postUserPref } from 'actions/userActions';
import { displayModal } from 'actions/modalActions';
import type { EditProfileValueType } from 'types/User';

export default connect(
  (state: StateType): StateProps => ({
    title: state.pageListState.title,
    excerpt: state.pageListState.excerpt,
    featured_media: state.pageListState.featured_media,
    meta_title: state.pageListState.meta_title,
    meta_description: state.pageListState.meta_description,
    sidebar_content: state.pageListState.sidebar_content,
    joueur: state.joueurState.joueur,
    status: state.pageListState.status,
    statusPlayer: state.joueurState.status,
    userPref: state.userState.userPref,
    error: state.userState.error
  }),
  (dispatch: DispatchType): DispatchProps => ({
    fetchPageList: (slug: string) => dispatch(fetchPageList(slug)),
    fetchJoueur: (slug: string) => dispatch(fetchJoueur(slug)),
    resetJoueur: () => dispatch(resetJoueur()),
    postUserPref: (action: string, value: EditProfileValueType, token: string) =>
      dispatch(postUserPref(action, value, token)),
    displayModal: (modalObject: string, content: Object) => dispatch(displayModal(modalObject, content))
  })
)(TeamPlayer);
